import { render, staticRenderFns } from "./DHead.vue?vue&type=template&id=5d756074&scoped=true&"
import script from "./DHead.vue?vue&type=script&lang=js&"
export * from "./DHead.vue?vue&type=script&lang=js&"
import style0 from "./DHead.vue?vue&type=style&index=0&id=5d756074&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d756074",
  null
  
)

export default component.exports